import React from "react";

export default function Hidden({ name, register }) {
  return <input type="hidden" {...register(name)} />;
}
